module.exports = __webpack_public_path__ + "static/media/BN.61960a0f.svg";